import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { UPDATE_CARDNAME, STATUS_SUCCESS_CODE, CAN_CREATE_SAVINGS_ACC } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import LineBreaks, { addLineBreaks, displayErrorMessage, displaySuccessMessage, MoreServices, retrieveData } from '../../../utils';
import check_img from '../../../assets/images/check_3x.png'
import beneficiarysaving from '../../../assets/images/beneficiarysaving.png';
import ClimbImg from '../../../assets/images/illo-climb.png';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import FooterContent from '../../../components/CustomComponents/Footer';
import HomeLayout from '../../../components/Layout/HomeLayout';
import HomeHeader from '../../../components/CustomComponents/HomeHeader';
import DynamicCard from '../../../components/CustomComponents/DynamicCard';
import Loader from '../../../components/CustomComponents/Loader';
import CustomAlertModel from '../../../components/CustomComponents/CustomAlertModel';
import logFirebaseEvents from '../../../components/LogFirebaseEvents';
import { width } from '../../../components/CustomComponents/DynamicCard/DynamicCardStyles';
import Approved from '../../../assets/images/Green_Tick.png'
import KudzuLogo from '../../../assets/images/kudzuLogo.png'
import Ach_acces from '../../../assets/kudzu-plus-images/ach_acces.png'
import KudzuPluseLogo from '../../../assets/kudzu-plus-images/small_logo_2.png';
import SavingsInteresrRate from '../../../assets/kudzu-plus-images/SavingsInteresrRate.png'
import CoveredbyKudzuplus from '../../../assets/kudzu-plus-images/CoveredbyKudzuplus.png'
import Frame from '../../../assets/kudzu-plus-images/Frame.png'
import ATM_small from '../../../assets/kudzu-plus-images/ATM_small.png'
import Security from '../../../assets/kudzu-plus-images/securityIcon.png'
import Checkbox from '../../../assets/kudzu-plus-images/start_button.png'
import GradientArrow from '../../../assets/kudzu-plus-images/active_image.png'
import CustomModalPlus from '../../helpers/customModalPlus';
import MemnershipEnrollmentScreens from '../membershipEnrollmentScreens';
import CustomCarousel from '../../helpers/customCarousel';
import CardHeading from '../../../components/CustomComponents/CardHeading';
import { appTheme, getUserMembership } from '../../../helpers/utils/Utils';
import ProgressBar from '../../../components/CustomComponents/ProgressBar';
import Handle from 'rc-slider/lib/Handles/Handle';
import { PAID_PROMO_KEY } from '../../../network/URLConstants';
import ComparisonOffer from '../Comparison offer';
import { GET_CLIMB_FEATURES , CLIMB_OPT_IN_OUT} from '../../../network/URLConstants';
import Modal from '../../../components/CustomComponents/Modal';
import RadialFill from '../../../assets/images/Checkbox-blue.png'
import { COVERED_BY_KUDZU } from '../../../network/URLConstants';
import debounce from 'lodash.debounce';
import { CHECKING_CARD_CODE } from '../../../helpers/utils/Utils';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';


const ManageMembershipKudzuPlus = ({ transactionDatas, onViewAllClick, viewAll , isSignUpAccept }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const { t } = useTranslation(); // Hook to access translation functions
  const cards = useSelector(state => JSON.parse(state.userCards));
  const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
  const accessTokenToApi = useSelector(state => state.accessToken);
  const [editClicked, setEditClicked] = useState(false);
  const [showCheckImage, setshowCheckImage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)




  const selectedItem = cards?.[0]
  const [newName, setNewName] = useState((selectedItem != undefined && selectedItem != null) ? selectedItem.NickName : "");

  const [loading, setLoading] = useState(false);
  const [infoMessage, setinfoMessage] = useState('');
  const [responseCode, setResponseCode] = useState('');
  const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[12px] md:text-[10px] sm:text-[6px] text-[8px] font-normal cursor-pointer pointer-events-none";
  const HeaderMsgStylesForPlus = "w-[240px] md:w-[399px] font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgPlusStyles = "sm:w-[399px] font-hanken-grotesk modal-title mt-[17px] md:text-[16px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-[400] cursor-pointer text-white";
  const dynamicfooterStyles = "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";

  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState('')
  const [savingsTheme, setSavingsTheme] = useState(false);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [isSubFooter, setIsSubFooter] = useState(false);
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [allButtonsDisable, setAllButtonsDisable] = useState(false);
  const [btn1TextColor, setBtn1TextColor] = useState("");
  const [footerText, setFooterText] = useState("");
  const [carousel, setCarousel] = useState('');
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const userMembershipData = getUserMembership(loggedResponse)
  const currentpath = useLocation()

  // climbe features state
  const climbFeatures = useSelector(state => state.climbFeatures);
  const issavingsGoalEligible = climbFeatures?.find(item => item?.code === "SavingsGoal");
  const isCoveredByKudzuPlusEligible = climbFeatures?.find(item => item?.code === "CoveredByKudzuPlus")
  const isCoveredByKudzuOptedIn = climbFeatures?.some(item => item.code === COVERED_BY_KUDZU && item.optedIn)
  //covered by kudzu plus opt in
  const SubHeadingStyles21 = "font-serif-pro modal-title sm:text-[18px] md:text-[36px]  text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)]";
  const SubHeadingStyles = "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]";
  const SubHeadingStyles4 = "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)] mb-4";
  const SubHeaderMsgStylesForSucces = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-[700] cursor-pointer pointer-events-none text-[var(--subway-head)]";
  const [isCoveredByKudzuIneligible, setIsCoveredByKudzuIneligible] = useState(false);
  const [isCoveredByKudzuDiscloserOpen, setIsCoveredByKudzuDiscloserOpen] = useState(false); 
  const [disclosureAgrmt, setDisclosureAgrmt] = useState(false);
    const [isCoveredByKudzuOptInSuccess, setIsCoveredByKudzuOptInSuccess] = useState(false);

    useDocumentTitle(t('page_title_manage_kudzu_plus'));

  const optinSuccessPopMessageFun = (isCbk) => {
        return (
            <>
                {isCbk ? (
                    <>
                        <span className={SubHeaderMsgStyles}>{t('Once_you_reach_your_Covered_Plus')}</span>{" "}
                        <span className={SubHeaderMsgStylesForSucces}>{t('covered_by_kudzu_plus')}</span>{" "}
                        <span className={SubHeaderMsgStyles}>{t('will_spot_you_up_to_$100_to_cover_plus')}</span>
                    </>
                ) :
                    (
                        <>
                            <span className={SubHeaderMsgStylesForSucces}>{t('covered_by_kudzu_plus')}</span> {" "}
                            <span className={SubHeaderMsgStyles}>{t('will_spot_you_up_to_$100_to_cover_plus')}</span>
                        </>
                    )}
            </>
        );
    };

     const coveredByKudzuPlusOptIn = async (item,isCbkOptIn) => {
          if (cards == null || cards == undefined) {
              return
          }
          setIsCoveredByKudzuDiscloserOpen(false);
  
          setIsLoading(true);
          const url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey) + 'CoveredByKudzuPlus' + '/opt-in'
          const deviceId = await retrieveData('updatedDeviceId')
          const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
          const response = await PostRequest(url, {}, headers)
  
          setTimeout(() => {
              setIsLoading(false)
          }, 500);
  
          const responseObj = JSON.parse(response);
  
          if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
              setIsCoveredByKudzuOptInSuccess(true);
          } else {
              setIsCoveredByKudzuDiscloserOpen(false);
              var arrMessages = responseObj.Messages;
              var message = arrMessages[0];
              var displayText = message.DisplayText;
              showAlertModal(true, t("covered_by_cudzu"), displayText, '', true, false, t("home"), '', true, require('../../../assets/images/warning.png'), false, false)
          }
  
      }
  
  const handleCoveredByKudzuOptIn = () => {
    if (isCoveredByKudzuPlusEligible?.isEligible) {

    } else {
      setIsCoveredByKudzuIneligible(true)
    }
  }

  const subComponent = () => {
    return (
      <div className=' flex justify-start items-start'>
        <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">{t("pl_contact_customer")}<a href="https://www.kudzumoney.com/contact-us" target="_blank" rel="noopener noreferrer" className="text-[#2965FB] cursor-pointer underline">{t("support_email")}</a>{t("for_access")}</p>
      </div>
    )
  }

  useEffect(() => {
  }, [cards, dispatch]);

  const closeCustomAlertModal = () => {
    setShowModel(false);
    setIsCoveredByKudzuDiscloserOpen(false)
    setIsCoveredByKudzuIneligible(false)
    setIsCoveredByKudzuOptInSuccess(false)
  }

  const onAcptBtnClick = async () => {
    setShowModel(false)
    if (btn1Text == t("enroll")) {
      navigate('/SetupSavingsAccount')
      dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
    } else if (btn1Text == t('home')) {
      navigate('/home')
    }

  }

  const onCancelBtnClick = () => {
    setShowModel(false)
    showAlertModal(true, '', t('savings_no_problem_title'), t('via_account_services_title'), true, false, t('okay_got_it'), '', true, beneficiarysaving, true, true);
  }

  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter) => {
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setSavingsTheme(savingsTheme)
    setisBorderNone(isBorderNone)
    setIsSubFooter(isSubFooter)
  }

  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists,
    btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor,
    summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable,
    gradientButton, largeImage, allButtonsDisable, btn1TextColor, footerText) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setGradientButton(gradientButton)
    setLargeImage(largeImage)
    setAllButtonsDisable(allButtonsDisable)
    setBtn1TextColor(btn1TextColor)
    setFooterText(footerText)

  }

  //without button card
  const footerContent = () => {
    return (
      <FooterContent highlightText={
        <p className='text-white md:w-[295px]'>{t('Most_of_Your')}
          <span className='text-[#94C3E8]'>{" "}{t('Kudzu+')}
          </span>{" "}{t('Membership')}.</p>
      }
        isSpace={true}
        type={'extendFlow'}
        subHeaderText="Learn about your exclusive features."
        image={KudzuPluseLogo} buttonEnabled={true} gradientBorder={true}
        buttonText="Explore Kudzu+"
        footerBtnAction={() => {
          showAlertModalPlus(
            true,
            t("thanks"),
            <div><p className='text-[#94C3E8]'>Let’s keep growing!</p>
              <p className='w-[400px]'>Explore all the features and benefits Kudzu+ has to offer.</p></div>,
            "",
            true,
            true,
            t('explore_feature'),
            t('back_to_home'),
            true,
            require('../../../assets/kudzu-plus-images/add-even-new.png'),
            "",
            true,
            "#262B3A",
            t('first_three_months_charged_automatically'),
            true,
            '',
            false,
            false,
            true,
            true,)
        }}
        borderDirection={'even'}
        isSubheadingwidth={false}
        largeImage={true}
      />
    )

  }


  const closeModelPlus = () => {
    setShowCarouselScreensShow(false);
    logFirebaseEvents("ManageMembershipCancelation", "Close_clicked", "Close_clicked", "", "");
    setShowPlusModal(false)
  }

  const onAcptBtnClickPlusModal = () => {
    if (btn1Text === t('setup_direct_deposit')) {
      navigate("/AccountServices/Spending/ManageDirectDeposit");
    }
    else if (btn1Text === t('enroll_in_savings')) {
      navigate("/SetupSavingsAccount");
    }
    else if (btn1Text === t('goto_savings')) {
      navigate("/Savings");
    }
     else if (btn1Text === t('go_to_toolkit')) {
      navigate("/Toolkit/ToolkitMenu");
    }
    else if (btn1Text === t('get_covered')) {
    
        showAlertModalPlus(true, '', '', "", true, true, '', t('Learn_More'), true, '',
        <CustomCarousel slidesData={coveredByKudzuPlusCarousels} dotsAbove={true} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal}
        />,
        true, "", "", true, "", false, false, false, false, true);
    }

    else if (btn1Text === t('create_savings_goal') || btn1Text ===  t("My_Saving_Goals")) {
      
       showAlertModalPlus(true, '', '', "", true, true, '', t('Learn_More'), true, '',
        <CustomCarousel slidesData={savingGoalsCarousels} dotsAbove={true} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal}
        />,
        true, "", "", true, "", false, false, false, false, true);
    }

    else if (btn1Text === t('findATMBtn')) {
      navigate("/Help/FindATM");
    }
    else if (btn1Text === t('explore_feature')) {
      showAlertModalPlus(true, '', '', "", true, true, '', t('Learn_More'), true, '',
        <CustomCarousel slidesData={newSlidesDataForFeatureCarousel} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal}
        />,
        true, "", "", true, "", false, false, false, false, true);
    } else if(btn1Text === t('enroll')){
       navigate("/SetupSavingsAccount");
    }

    else {
      logFirebaseEvents("ManageMembershipCancelation", "downgrade_to_kudzu_Clicked", "downgrade_to_kudzu_Clicked", "", "");
      navigate("/kudzuplusSecurity", { state: { type: t('downgrad_to_kudzu_plus') } });
    }

  }

  const onCancelBtnClickPlusModal = () => {
    logFirebaseEvents("ManageMembershipCancelation", "Cancel_clicked", "Cancel_clicked  ", "", "");
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
      setShowPlusModal(false)
      navigate("/home");
    }, 1000);
  }

  const handleTermsClick = () => {
    if (accessTokenToApi == undefined || accessTokenToApi == null) {
      return;
    }
    else {
      navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', {
        state: {
          name: 'Covered by Kudzu Terms and Conditions',
          url:
            userMembershipData?.membershipType === "Plus" ||
              userMembershipData?.membershipType === "Trial"
              ? "CoveredByKudzuPlusTerms"
              : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey
        }
      });

    }
  }

  const hasSavingsAccount = cards?.some(item => item.AccountTypeName === "Savings");

  const slidesDataForFeatureCarousel = [
    {
      heading: <div><p className='text-[#94C3E8]'>Let’s keep growing!</p>
        <p className='w-[400px]'>Explore all the features and benefits Kudzu+ has to offer.</p></div>,
      paragraph: '',
      imageUrl: require('../../../assets/kudzu-plus-images/add-even-new.png'),
      carouselAcceptBtnText: '',
      carouselCancelBtnText: 'Back to Home',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      footerTextForUpgrade: t("first_three_months_charged_automatically"),
      dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
    {
      heading: addLineBreaks(t('Access_Direct_Depo_explore_carousel')),
      paragraph: '',
      videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-ach.mp4'),
      carouselAcceptBtnText: 'Set up Direct Deposit',
      carouselCancelBtnText: 'Back to Home',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { navigate("/AccountServices/Spending/ManageDirectDeposit") },
      footerTextForUpgrade: t("Access_Direct_footer_explore_carousel"),
      dynamicfooterStyles: "font-hanken-grotesk w-[455px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
    {
      heading: addLineBreaks(t('save_with_explore_carousel')),
      paragraph: <p>{t("plan_future_para")}{" "}
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltip = e.currentTarget.querySelector('.tooltip');
            if (!tooltip) return;

            const isVisible = tooltip.style.display === 'block';
            tooltip.style.display = isVisible ? 'none' : 'block';

            // Close the second tooltip if it's open
            const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
            if (tooltipAPY && tooltipAPY.style.display === 'block') {
              tooltipAPY.style.display = 'none';
            }

            if (!isVisible) {
              const handleClickOutside = (event) => {
                if (tooltip && !tooltip.contains(event.target)) {
                  tooltip.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}

        >
          {addLineBreaks(t("Saving"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>
        <br></br>
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
        >
          {addLineBreaks(t("Goal"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                        p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                        shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>{" "}
        {" "}{t("para_saving_goals_sec_part")}{" "}
        <span
          className="!text-[#94C3E8] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltips = e.currentTarget.querySelector('.tooltipAPY');
            if (!tooltips) return;

            const isVisibleAPY = tooltips.style.display === 'block';
            tooltips.style.display = isVisibleAPY ? 'none' : 'block';

            // Close the first tooltip if it's open
            const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
            if (tooltip && tooltip.style.display === 'block') {
              tooltip.style.display = 'none';
            }

            if (!isVisibleAPY) {
              const handleClickOutside = (event) => {
                if (tooltips && !tooltips.contains(event.target)) {
                  tooltips.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {t("para_saving_goals_third_part")}
          <div
            className={`tooltipAPY hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                             p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                             shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
          </div>
        </span>
      </p>,
      dynamicSubHeaderStyles: "sm:w-[396px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]",
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
      carouselCancelBtnText: 'Back to Home',
      carouselAcceptBtnText: hasSavingsAccount ? "Go to Savings" : 'Enroll in Savings',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => {
        navigate(hasSavingsAccount ? "/Savings" : "/SetupSavingsAccount")
      },
      footerTextForUpgrade: <p>{t("APY_Desclaimer_Date")}<a
        href="https://kudzumoney.com/policies#savings-rate-information"
        target="_blank"
        rel="noopener noreferrer"
        className="underline cursor-pointer"
      >
        {t("View_full_Details")}
      </a></p>,
      dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },

    {
      heading: addLineBreaks(t('cover_insufficient_funds')),
      paragraph: '',
      imageUrlAlter: require('../../../assets/kudzu-plus-images/overdraft_imag.png'),
      carouselAcceptBtnText: 'Get Covered',
      carouselCancelBtnText: 'Back to Home',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { navigate("/Toolkit/ToolkitMenu") },
      footerTextForUpgrade: <>{t("covered_by_kudzu_climb_footer_new_updated")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('kudzu_navigate_link')}</span></>,
      dynamicfooterStyles: "font-hanken-grotesk w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },

    {
      heading: addLineBreaks(t('Save_On_Out_Of_NetWork_Atm')),
      paragraph: '',
      videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-atm.mp4'),
      getstartTrue: true,
      carouselAcceptBtnText: 'Find an ATM',
      carouselCancelBtnText: 'Back to Home',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { navigate("/Help/FindATM") },
      footerTextForUpgrade: t("free_atm_footer"),
      dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
  ];

  const newSlidesDataForFeatureCarousel = [
    {
      heading: addLineBreaks(t('Access_Direct_Depo_explore_carousel')),
      paragraph: '',
      videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-ach.mp4'),
      carouselAcceptBtnText: 'Set up Direct Deposit',
      carouselCancelBtnText: 'Back to Home',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { navigate("/AccountServices/Spending/ManageDirectDeposit") },
      footerTextForUpgrade: t("Access_Direct_footer_explore_carousel"),
      dynamicfooterStyles: "font-hanken-grotesk w-[455px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
    {
      heading: addLineBreaks(t('save_with_explore_carousel')),
      paragraph: <p>{t("plan_future_para")}{" "}
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltip = e.currentTarget.querySelector('.tooltip');
            if (!tooltip) return;

            const isVisible = tooltip.style.display === 'block';
            tooltip.style.display = isVisible ? 'none' : 'block';

            // Close the second tooltip if it's open
            const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
            if (tooltipAPY && tooltipAPY.style.display === 'block') {
              tooltipAPY.style.display = 'none';
            }

            if (!isVisible) {
              const handleClickOutside = (event) => {
                if (tooltip && !tooltip.contains(event.target)) {
                  tooltip.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}

        >
          {addLineBreaks(t("Saving"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>
        <br></br>
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
        >
          {addLineBreaks(t("Goal"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                        p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                        shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>{" "}
        {" "}{t("para_saving_goals_sec_part")}{" "}
        <span
          className="!text-[#94C3E8] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltips = e.currentTarget.querySelector('.tooltipAPY');
            if (!tooltips) return;

            const isVisibleAPY = tooltips.style.display === 'block';
            tooltips.style.display = isVisibleAPY ? 'none' : 'block';

            // Close the first tooltip if it's open
            const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
            if (tooltip && tooltip.style.display === 'block') {
              tooltip.style.display = 'none';
            }

            if (!isVisibleAPY) {
              const handleClickOutside = (event) => {
                if (tooltips && !tooltips.contains(event.target)) {
                  tooltips.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {t("para_saving_goals_third_part")}
          <div
            className={`tooltipAPY hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                             p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                             shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
          </div>
        </span>
      </p>,
      dynamicSubHeaderStyles: "sm:w-[396px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]",
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
      carouselCancelBtnText: 'Back to Home',
      carouselAcceptBtnText: hasSavingsAccount ? "Go to Savings" : 'Enroll in Savings',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => {
        hasSavingsAccount ? navigate("/Savings") : canCreateSavingsAccount()
      },
      footerTextForUpgrade: <p>{t("APY_Desclaimer_Date")}<a
        href="https://kudzumoney.com/policies#savings-rate-information"
        target="_blank"
        rel="noopener noreferrer"
        className="underline cursor-pointer"
      >
        {t("View_full_Details")}
      </a></p>,
      dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },

    {
      heading: addLineBreaks(t('cover_insufficient_funds')),
      paragraph: '',
      imageUrlAlter: require('../../../assets/kudzu-plus-images/overdraft_imag.png'),
      carouselAcceptBtnText: 'Get Covered',
      carouselCancelBtnText: 'Back to Home',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { navigate("/Toolkit/ToolkitMenu") },
      footerTextForUpgrade: <>{t("covered_by_kudzu_climb_footer_new_updated")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('kudzu_navigate_link')}</span></>,
      dynamicfooterStyles: "font-hanken-grotesk w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },

    {
      heading: addLineBreaks(t('Save_On_Out_Of_NetWork_Atm')),
      paragraph: '',
      videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-atm.mp4'),
      getstartTrue: true,
      carouselAcceptBtnText: 'Find an ATM',
      carouselCancelBtnText: 'Back to Home',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { navigate("/Help/FindATM") },
      footerTextForUpgrade: t("free_atm_footer"),
      dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
  ];


  const enrollSavingsAccount = () => {
     setShowPlusModal(false)
      if(kudzuPlusTrue){
            showAlertModalPlus(true,"" ,
                  promoKey == PAID_PROMO_KEY ? t("Get_1.25%_APY_on_an_optional_savings_account_with_trial") : t('Get_1.25%_APY_on_an_optional_savings_account'),
                  "", true, true,  t("enroll"),  t("may_be_later"), true, require('../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
                  '',
                  true, '', false, false, true, true);
      }
      else{
      showAlertModal(true, '', t('set_aside_money_for_the_things_that_matter'), t('add_savings_account_subTitle'), true, true, t('enroll'), t('may_be_later'), true,beneficiarysaving, true, true);
      }
    }


  const canCreateSavingsAccount = async () => {
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      setIsLoading(true)
  
  
      let finalUrl = CAN_CREATE_SAVINGS_ACC(cards[0].CardKey)
      var response = await GetRequest(finalUrl, headers)
      var responseObj = JSON.parse(response)
      setIsLoading(false)
      if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
          const canCreateNew = responseObj.Response.canCreateNew
          const eligibleDate = moment(responseObj.Response.eligibleDate).format('MM/DD/YYYY')
          if (canCreateNew) {
            enrollSavingsAccount()
          } else {
            setShowPlusModal(false)
              showAlertModal(true, t("oh_no"), t('unable_to_open'), `${t('u_will_be_eligible')} ${eligibleDate}. `, true, false, t('home'), '', true, require('../../../assets/images/illo-report.png'), false, false, true)
          }
      } else {
    
              var arrMessages = responseObj.Messages;
              var message = arrMessages[0];
              var displayText = message.DisplayText;
              var displayText = message.DisplayText;
               setShowPlusModal(false)
               showAlertModal(true, t("oh_no"), <p className={`${kudzuPlusTrue ? 'text-white' : ''}`}>{displayText}</p>, '', true, false, t('home'), '', true, require('../../../assets/images/illo-report.png'), false, false)
               
      }
  }

  const savingGoalsCarousels = [
    {
     
      heading: <>{<p>{t('with_setting')}<span className='text-[#94C3E8]'>{t('Saving_Goal_Overly')}</span>{t('with_saving_gola_intro_one')}</p>}</>,
      paragraph: '',
      imageUrl: require('./../../../assets/kudzu-plus-images/illo_piggy_goal.png'),
      carouselAcceptBtnText: issavingsGoalEligible?.hasConfigurations ? t("My_Saving_Goals") : t("saving_goal_primary_button"),
      carouselCancelBtnText: 'Maybe Later',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => {savingsCardAvailable ? issavingsGoalEligible?.optedIn ? navigate("/Toolkit/SavingGoals/ManageSavingGoal") :  navigate("/Toolkit/ToolkitSettings") : canCreateSavingsAccount()},
      dynamicfooterStyles: "font-hanken-grotesk w-[455px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    }, 
    {
      heading: <>{<p>{t('your_unique')}<span className='text-[#94C3E8]'>{t('saving_goal_overly_two')}</span>{t('saving_goal_intro_two')}</p>}</>,
      paragraph: '',
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
      carouselAcceptBtnText: issavingsGoalEligible?.hasConfigurations ? t("My_Saving_Goals") : t("saving_goal_primary_button"),
      carouselCancelBtnText: 'Maybe Later',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
        carouselAcceptBtnClick: () => {savingsCardAvailable ? issavingsGoalEligible?.optedIn ? navigate("/Toolkit/SavingGoals/ManageSavingGoal") :  navigate("/Toolkit/ToolkitSettings") : canCreateSavingsAccount()},
      dynamicfooterStyles: "font-hanken-grotesk w-[455px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
    {
      heading: <>{<p>{t('each_regular')}<span className='text-[#94C3E8]'>{t('regular_goal')}</span>{t('saving_goal_intro_three')}</p>}</>,
      paragraph: '',
      imageUrl: require('./../../../assets/kudzu-plus-images/saving_goal_tree.png'),
      carouselAcceptBtnText:  issavingsGoalEligible?.hasConfigurations ? t("My_Saving_Goals") : t("saving_goal_primary_button"),
      carouselCancelBtnText: 'Maybe Later',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
       carouselAcceptBtnClick: () => {savingsCardAvailable ? issavingsGoalEligible?.optedIn ? navigate("/Toolkit/SavingGoals/ManageSavingGoal") :  navigate("/Toolkit/ToolkitSettings") : canCreateSavingsAccount()},
      dynamicfooterStyles: "font-hanken-grotesk w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    }
  ];

  const coveredByKudzuPlusCarousels = [
    {
      heading: <>{<p><span className='text-[#94C3E8]'>{t('cbk_plus_settings')}</span>{t('settings_cbk+_intro_one_header')}</p>}</>,
      paragraph: '',
      imageUrl: require('./../../../assets/kudzu-plus-images/umbrella_cbk.png'),
      carouselAcceptBtnText:  t("cbk_plus_activate"),
      carouselCancelBtnText: 'Maybe Later',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { if(isCoveredByKudzuPlusEligible?.isEligible){
        setShowPlusModal(false)
        setIsCoveredByKudzuDiscloserOpen(true
        )}else{
        setShowPlusModal(false)
        setIsCoveredByKudzuIneligible(true)} },
      footerTextForUpgrade: <>{t("setting_cbk_content")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('link_setting_cbk')}</span>{t("settings_cbk_content_two")}<span className="underline cursor-pointer" onClick={handleTermsClick}>{t('settings_cbk_link_two')}</span></>,
      dynamicfooterStyles: "font-hanken-grotesk w-[455px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
    {
      heading: <>{<p><span className='text-[#94C3E8]'>{t('minimum_fifty')}</span>{t('settings_cbk+_intro_two_header')}</p>}</>,
      paragraph: '',
      imageUrl: require('./../../../assets/kudzu-plus-images/savings_spending.png'),
      carouselAcceptBtnText:  t("cbk_plus_activate"),
      carouselCancelBtnText: 'Maybe Later',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { if(isCoveredByKudzuPlusEligible?.isEligible){
        setShowPlusModal(false)
        setIsCoveredByKudzuDiscloserOpen(true)}else{
        setShowPlusModal(false)
        setIsCoveredByKudzuIneligible(true)} },
      dynamicfooterStyles: "font-hanken-grotesk w-[455px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
    {
      heading: <>{<p>{t('settings_cbk_+_intro_three_header')}<span className='text-[#94C3E8]'>{t('up_to_ten_months')}</span></p>}</>,
      paragraph: '',
      imageUrl: require('./../../../assets/kudzu-plus-images/tenx.png'),
      carouselAcceptBtnText: t("cbk_plus_activate"),
      carouselCancelBtnText: 'Maybe Later',
      carouselCancelBtnClick: onCancelBtnClickPlusModal,
      carouselAcceptBtnClick: () => { if(isCoveredByKudzuPlusEligible?.isEligible){
        setShowPlusModal(false)
        setIsCoveredByKudzuDiscloserOpen(true)}else{
        setIsCoveredByKudzuIneligible(true)} },
      dynamicfooterStyles: "font-hanken-grotesk w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    }
  ];


  const handleFeatutesModal = (caseType) => {
    let title, description, primaryBtnText, secondaryBtnText, imageSrc, videoSrc, footerTextModal, dynamicfooterStylesModal;

    switch (caseType) {
      case "achAccess":
        title = '';
        description = t('Access_individual_head_one');
        primaryBtnText = t('setup_direct_deposit');
        secondaryBtnText = t('back_to_home_individual');
        imageSrc = false;
        videoSrc = require('./../../../assets/videos/freeTrailVideos/kudzu-plus-ach.mp4');
        footerTextModal = t("Access_Direct_footer_explore_carousel");
        dynamicfooterStylesModal = "font-hanken-grotesk w-full sm:w-[455px]  mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
        break;

      case "savingsInteresrRate":
        // title = '';
        title =
          <p>
            {t("plan_future_para")}
            <span
              className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
              onClick={(e) => {
                e.stopPropagation();
                const tooltip = e.currentTarget.querySelector('.tooltip');
                if (!tooltip) return;

                const isVisible = tooltip.style.display === 'block';
                tooltip.style.display = isVisible ? 'none' : 'block';

                // Close the second tooltip if it's open
                const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
                if (tooltipAPY && tooltipAPY.style.display === 'block') {
                  tooltipAPY.style.display = 'none';
                }

                if (!isVisible) {
                  const handleClickOutside = (event) => {
                    if (tooltip && !tooltip.contains(event.target)) {
                      tooltip.style.display = 'none';
                      document.removeEventListener('click', handleClickOutside);
                    }
                  };
                  setTimeout(() => {
                    document.addEventListener('click', handleClickOutside);
                  }, 0);
                }
              }}
            >
              {addLineBreaks(t("Saving"))}
              <div
                className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000 leading-snug`}
              >
                <div className="tooltip-arrow-comparion"></div>
                <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
              </div>
            </span>{" "}
            <br></br>
            <span
              className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
            >
              {addLineBreaks(t("Goal"))}
              <div
                className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
              >
                <div className="tooltip-arrow-comparion"></div>
                <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
              </div>
            </span>{" "}
            {t("para_saving_goals_sec_part")}{" "}
            <span
              className="!text-[#94C3E8] cursor-pointer relative inline-block"
              onClick={(e) => {
                e.stopPropagation();
                const tooltips = e.currentTarget.querySelector('.tooltipAPY');
                if (!tooltips) return;

                const isVisibleAPY = tooltips.style.display === 'block';
                tooltips.style.display = isVisibleAPY ? 'none' : 'block';

                // Close the first tooltip if it's open
                const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
                if (tooltip && tooltip.style.display === 'block') {
                  tooltip.style.display = 'none';
                }

                if (!isVisibleAPY) {
                  const handleClickOutside = (event) => {
                    if (tooltips && !tooltips.contains(event.target)) {
                      tooltips.style.display = 'none';
                      document.removeEventListener('click', handleClickOutside);
                    }
                  };
                  setTimeout(() => {
                    document.addEventListener('click', handleClickOutside);
                  }, 0);
                }
              }}
            >
              {t("para_saving_goals_third_part")}
              <div
                className={`tooltipAPY hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000 leading-snug`}
              >
                <div className="tooltip-arrow-comparion"></div>
                <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
              </div>
            </span><span>.</span>
          </p>;
        description = <p className='md:!w-[409px]'>{t("heading_saving_goals")}</p>;
        // description = <p>{t("plan_future_para")}<span className='text-[#94C3E8]'>{t("para_saving_goals")}</span>{t("para_saving_goals_sec_part")}<span className='text-[#94C3E8]'>{t("para_saving_goals_third_part")}</span></p>
        primaryBtnText = hasSavingsAccount ? t('goto_savings') : t('enroll_in_savings');
        secondaryBtnText = t('back_to_home_individual');
        imageSrc = false;
        footerTextModal = <p className="text-[#94C3E8] pt-14  lg:text-[12px] md:text-[14px] "> {t("APY_Desclaimer_Date")}<a
          href="https://kudzumoney.com/policies#savings-rate-information"
          target="_blank"
          rel="noopener noreferrer"
          className="underline cursor-pointer"
        >
          {t("View_full_Details")}
        </a></p>;
        dynamicfooterStylesModal = "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
        // videoSrc = require('./../../../assets/videos/freeTrailVideos/Savings_APY.mp4');
        videoSrc = require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4');
        break;
      //new change
      case "coveredByKudzuPlus":
        title = '';
        description = <p className='lg:text-[30px]'>{t('cover_insufficient_funds_Update')}</p>
        primaryBtnText = isCoveredByKudzuPlusEligible?.optedIn ? t('go_to_toolkit'):t('get_covered');
        secondaryBtnText = t('back_to_home_individual');
        imageSrc = require('../../../assets/kudzu-plus-images/overdraft_imag.png');
        footerTextModal = <>{t("covered_by_kudzu_climb_footer_new_updated")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('kudzu_navigate_link')}</span></>;
        dynamicfooterStylesModal = "font-hanken-grotesk w-full sm:w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[10px] font-[400]"
        videoSrc = false;
        break;

      case "savingsGoals":
        title = '';
        description = t('work_toward_unique_savings');
        primaryBtnText = issavingsGoalEligible?.hasConfigurations ? t("My_Saving_Goals") : t('create_savings_goal')
        secondaryBtnText = t('back_to_home_individual');
        imageSrc = false;
        footerTextModal = <p className="text-[#94C3E8] pt-14  lg:text-[12px] md:text-[14px] "> {t("APY_Desclaimer_Date")}<a
          href="https://kudzumoney.com/policies#savings-rate-information"
          target="_blank"
          rel="noopener noreferrer"
          className="underline cursor-pointer"
        >
          {t("View_full_Details")}
        </a></p>;
        dynamicfooterStylesModal = "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
        videoSrc = require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4');
        break;

      case "ATMWithdrawals":
        title = '';
        description = t('ATM_New_Text');
        primaryBtnText = t('findATMBtn');
        secondaryBtnText = t('back_to_home_individual');
        imageSrc = false;
        footerTextModal = t("free_atm_footer");
        dynamicfooterStylesModal = "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
        videoSrc = require('./../../../assets/videos/freeTrailVideos/kudzu-plus-atm.mp4');
        break;

      default:
        console.error("Invalid case type");
        return;
    }


    showAlertModalPlus(true, title, description, title, true, true, primaryBtnText, secondaryBtnText, true, imageSrc,
      videoSrc ? <video className="block m-auto" alt="video" style={{ maxHeight: "300px", maxWidth: "300px", background: "transparent" }} autoPlay muted loop preload="auto" playsInline> <source src={videoSrc} type="video/mp4" /> </video> : '',
      true, "#262B3A", '', true, '', false, true, true, true, false, '#FFFFFF', <><p className={dynamicfooterStylesModal}>{footerTextModal}</p></>
    );
  };


   const spendingCard = cards?.find(
      (item) =>
        item.ProgramKey === 200 &&
        item.AccountTypeBit63 === 64
    );
    
  //climb features api call  
  const isPrimrayKey = cards !== null ? cards[0].CardKey : 0;
  const accessToken = useSelector(state => state.accessToken);
  const [isClimbings, setisClimbings] = useState([]);

  const getClimbFeatures = async () => {
    setIsLoading(true);
    const deviceId = await retrieveData('updatedDeviceId')
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_CLIMB_FEATURES.replace('{CARD_KEY}', spendingCard.CardKey)
    const response = await GetRequest(url, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
      const enabledClimbings = responseJson.Response.filter(
        (response) => response.enabled === true

      );
      setisClimbings(enabledClimbings);
      dispatch({ type: 'UPDATE_CLIMB_FEATURE', payload: { climbFeatures: responseJson.Response } })
      setIsLoading(false);
    } else {
      return [];
    }

  }

  useEffect(() => {
     getClimbFeatures()
  },[])

  const isClimbFeatureOptedIn = (code) => {
  return isClimbings.find(item => item.code === code)?.optedIn === true;
 };
 
  
  const features = [

    {
      icon: Ach_acces,
      text: "2 Day Early ACH Access",
      endIcon: Checkbox,
      id: "achAccess"
    },
    {
      icon: SavingsInteresrRate,
      text: "1.26% Annual Percentage Yield (APY)",
      endIcon: hasSavingsAccount ? GradientArrow : Checkbox,
      id: "savingsInteresrRate"
    },
    {
      icon: CoveredbyKudzuplus,
      text: "Covered by Kudzu+",
      endIcon: isClimbFeatureOptedIn("CoveredByKudzuPlus") ? GradientArrow : Checkbox,
      id: "coveredByKudzuPlus"
    },
    {
      icon: Frame,
      text: "Savings Goals",
      endIcon: isClimbFeatureOptedIn("SavingsGoal") ? GradientArrow : Checkbox,
      id: 'savingsGoals'
    },
    {
      icon: ATM_small,
      text: "No Out-of-Network ATM Withdrawal Fees",
      endIcon: GradientArrow,
      id: 'ATMWithdrawals'
    }
  ];

 const gradientIconLength = features?.filter((gradientIcon) => gradientIcon?.endIcon === GradientArrow)?.length



  const handleNavigateTolearnMore = () => {
    debugger
    const currentPath = { currentPathFromStore: location.pathname };
    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
    if (userMembershipData?.extendTrial) {
      logFirebaseEvents("ManageMembership", "Extend_kudzu_Clicked", "Extend_kudzu_Clicked", "", "");
      setShowCarouselScreensShow((prev) => !prev);
      const data = { kudzuFlowFrom: "fromExtendFlow" };
      dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
    }
    else {

      logFirebaseEvents("ManageMembership", "Explore_Features_&_Benefits_Clicked", "Explore_Features_&_Benefits_Clicked", "", "");
      showAlertModalPlus(true, '', '', "", true, true, '', t('Learn_More'), true, '', <CustomCarousel slidesData={slidesDataForFeatureCarousel} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal} finalButtontextChange={t('done')} dotsAbove={true} forClimbBtn={true} forClimbHomeBtn={true} />, true, "", "", true, "", false, false, false, false, true);
    }
  }

  const [comparisonClickFrom, setComparisonClickFrom] = useState("");
  const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
  const [selectedType, setSelectedType] = useState(location.state?.type);
  const [show2faSelection, setshow2faSelection] = useState(false);

  const handleFeatutes = (fromClick) => {
    setComparisonClickFrom(fromClick)
    showAlertModalPlus(true, '', promoKey == PAID_PROMO_KEY || userMembershipData?.extendTrial ? t('access_exclusive_features_and_benefits_with_kudzu_membership') : t('Access_exclusive_features_and_benefits'), "", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={handlOkComparison} />, true, false);
  }

  const handlOkComparison = () => {
    setSelectedType(t('upgrade_to_kduzu_plus'))
    setShowPlusModal(false)
    setshow2faSelection(true)
  }

  const acceptHandleForClimb = () => {
    showAlertModalPlus(false)
    setLoading(true)
    setTimeout(() => {
      showAlertModalPlus(true, '', promoKey == PAID_PROMO_KEY || userMembershipData?.extendTrial === true ? t('access_exclusive_features_and_benefits_with_kudzu_membership') : t('Access_exclusive_features_and_benefits'), "", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={isSignUpAccept} isKudzuPlus={true} />, true, false);
      setLoading(false)
    }, 1000);
    logFirebaseEvents("Membership_Enrollment", "Kudzu_Plus_Begin_Free_Trial_Clicked", "Kudzu_Plus_Begin_Free_Trial_Clicked", "", "");
  }
    

  const handleCancelMembership = () => {
    logFirebaseEvents("ManageMembershipCancelation", "Cancel_Kudzu+_Membership_Clicked", "Cancel_Kudzu+_Membership_Clicked", "", "");
    const currentPath = { currentPathFromStore: location.pathname };
    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });

    const modalContent = userMembershipData?.membershipType === "Plus"
      ? (<p>{t("KudzuPlus_Cancellation_SubHeading")}</p>)
      : (
        <p className='font-[300]'>
          {t("By_Cancelling")}
          <span
            className='font-bold'
            onClick={acceptHandleForClimb}
            style={{ cursor: 'pointer' }}
          >
            {t("Kudzu_update_link")}
          </span>
        </p>
      );
    showAlertModalPlus(true, t("thanks"), t("Do_you_want_to_downgrade_to_Kudzu"),
      modalContent
      , true, true, t('Downgrade_to_Kudzu'), t('Cancel'), true, require('./../../../assets/kudzu-plus-images/New_logo_kudzu.png'), "", true, "#262B3A", '', true, '', false, true, false, true, false);
  }

  const extendFlowCloseCallbackFunction = (val) => {
    setShowCarouselScreensShow(val)
  }

  const handleComparisonBackClick = () => {
    navigate("/home")
  }
    
     
  const headingContent = userMembershipData?.membershipType === "Plus"
    ? addLineBreaks(t("Take_advantage_of_your_Kudzu+_membership"))
    : userMembershipData?.membershipType === "Trial"
      ? addLineBreaks(t("Take_advantage_of_your_Kudzu+_trial"))
      : "";

    return (

        <HomeLayout>

            <HomeHeader heading={headingContent} isHeaderCaption={true} />
            {showCarouselScreenShow &&
                <MemnershipEnrollmentScreens extendFlowCloseCallbackFunction = {extendFlowCloseCallbackFunction} />}
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]    animate__animated animate__fadeInRight '>
                <DynamicCard
                    header={false}
                    footer={true}
                    CardRadius={true}
                    HeaderRadius={true}
                    cardWidth={width.homeCard}
                    isWhite={appThemeData.isWhiteBgForCard}
                    isDarkForKudzu={appThemeData.isDarkBgForCard}
                    backgroundColor={'--cardHeading-bg'}
                    HeaderContent={
                        <>
                            <CardHeading heading={t('Kudzu+')} imageEnd={true} image={Approved} />
                        </>
                    }
                >

                    <div className='sm:mx-0 mx-4 md:mt-20 mt-16'>
                        <div className='flex justify-between text-white mb-6 font-hanken-grotesk font-semibold'>
                            <div className='uppercase tracking-[4px]'>activE features</div>
                            <div>{gradientIconLength + " "  + '/' + "  " + features?.length}</div>
                        </div>

                        <ProgressBar filledbgColor={"linear-gradient(109.08deg, #00654F 12.11%, #0B7A5D 57.56%, #29B081 102.11%)"} unfilledBg={"#324261"} progressBarWidth={"100%"} progressBarHeight={"6px"} progress={gradientIconLength * 20} />
                    </div>

                    <div className='flex flex-col justify-center mt-10 items-center sm:mx-0 mx-4 mb-10'>
                        <div className='w-[90%] text-white'>

                            <div className="flex flex-col gap-14 mt-4">
                                {features.map((feature, index) => (
                                    <div key={index} className="flex justify-between items-center cursor-pointer">
                                        <div className="flex items-center gap-4" onClick={() => handleFeatutesModal(feature.id)}>
                                            <img src={feature.icon} alt={feature.text} />
                                            <p className="font-bold font-hanken-grotesk md:text-[15px] sm:text-[13px] uppercase tracking-[4px]">{feature.text}</p>
                                        </div>
                                        <img className='w-16 h-7' src={feature.endIcon} alt={feature.endIcon} onClick={() => feature.endIcon === GradientArrow ? handleFeatutesModal(feature.id) : handleFeatutesModal(feature.id)} />
                                    </div>
                                ))}
                            </div>

                            <div className='mt-8 flex items-center flex-col justify-center'>
                                {userMembershipData?.extendTrial && (
                                    <>
                                        <button
                                            type="button"
                                            onClick={handleNavigateTolearnMore}
                                            className="flex items-center justify-center rounded-full md:w-[37%] w-full h-[45px]  border-2 border-[#30BC89] p-[4px] text-white lg:text-[16px] md:text-[18px] sm:text-[11px] text-[14px] leading-[13px] md:leading-[26px] font-[700] font-hanken-grotesk"
                                            data-te-ripple-init
                                        >
                                            <div className="flex h-full text-[12px] md:text-[14px] items-center justify-center rounded-full w-full bg-[#2C3449]">
                                                {t('Extend_Membership')}
                                            </div>
                                        </button>

                                        <div
                                            className="text-[#94C3E8] font-normal font-hanken-grotesk mt-4"
                                        >
                                            <span>{userMembershipData?.daysRemaining}</span>&nbsp;Days Remaining
                                        </div>
                                    </>
                                )}

                                {(!userMembershipData?.extendTrial && userMembershipData?.membershipType === "Plus") && <button type='button' onClick={handleCancelMembership} className='text-[#94C3E8] font-normal font-hanken-grotesk underline mt-4'
                                >{t("Cancel_Kudzu_membership")}</button>}
                            </div>
                <div>
                  {userMembershipData?.membershipType === 'Trial' && (
                    <div className="flex flex-col md:flex-row items-center justify-between md:space-x-0 space-y-4 md:space-y-0 mt-4">
                      {/* Info row: date + cancel */}
                      <div className="flex flex-row items-center justify-center md:justify-between order-2 md:order-1 w-full md:w-auto gap-12 md:gap-32">
                        <p className="text-center md:text-left w-auto">
                          {t('trail_ends')} {new Date(loggedResponse.Subscription.TrailEndDate).toLocaleString('en-US', {
                            month: 'short',
                            day: 'numeric'
                          })}
                        </p>
                        <button
                          type="button"
                          onClick={handleCancelMembership}
                          className="text-[#94C3E8] font-normal font-hanken-grotesk text-center md:text-left"
                        >
                          {t("Cancel_Kudzu_Trial_membership")}
                        </button>
                      </div>


                      {/* Button */}
                      <div className="order-1 md:order-3 w-full md:w-auto p-0 md:p-0 pb-8 md:pb-0">
                        <button
                          type="button"
                          className="flex items-center justify-center rounded-full w-full md:w-[210px] h-[55px] border-2 border-[#30BC89] p-[2px] text-white text-[14px] leading-[13px] font-[700] font-hanken-grotesk"
                          data-te-ripple-init
                        >
                          <div className="flex h-full items-center justify-center rounded-full w-full bg-[#2C3449] text-[18px] font-bold">
                            <span>{loggedResponse.Subscription.TrailRemainingDaysText}</span>&nbsp;Remaining
                          </div>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                        </div>
                    </div>

                    {loading && <Loader />}
                </DynamicCard>
                {footerContent()}

            </div>

         {isCoveredByKudzuIneligible &&<Modal
                    isOpen={isCoveredByKudzuIneligible}
                    onClose={debounce(closeCustomAlertModal,100)}
                    isClimbg={true}
                    Fullheight={true}
                    subtitle={<div className="">
                        <span className={SubHeadingStyles4}>{t('sorry')}, </span>
                        <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                        <p className='mt-4 font-hanken-grotesk font-[500] md:text-[19px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                            {t("you_need_minimum_100_spending")} <span className='text-[var(--modal-text-highlight)] cursor-pointer' onClick={ handleTermsClick }>{t('here')}</span>.</p>
                    </div>
                    }
                    content={<div>

                        <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon}
                            className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt="" />

                        <div className="flex flex-col justify-center items-center gap-8 w-full">
                            <button
                                type="button"
                                className="focus:outline-none   w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                                onClick={() => { navigate('/AccountServices/Spending/TransferMoney') }}
                                autoFocus
                            >
                                {t('Add_Money_to_Spending')}
                            </button>
                            <button
                                type="button"
                                className="w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--can-clr)] cursor-pointer flex justify-center items-center border-[3px] border-[#2965FB] sm:border-0 p-4"
                                onClick={(() => {setIsCoveredByKudzuIneligible(false);navigate('/Toolkit/ToolkitMenu');})}>
                                {t('Back to Toolkit')}
                            </button>
                        </div>
                    </div>}
                />}

           {isCoveredByKudzuDiscloserOpen &&<Modal
                    isOpen={isCoveredByKudzuDiscloserOpen}
                    Fullheight={true}
                    onClose={closeCustomAlertModal}
                    isClimbg={true}
                    subtitle={
                        <span className={SubHeadingStyles}>{t('coveredby_kudzu_Plus_terms')}</span>
                    }
                    content={<div className="md:pt-1 sm:pt-1 pb-2">
                       
                        <p className="font-hanken-grotesk lg:text-[16px] md:text-[16px] sm:text-[10] sm:leading-[16px]
                         text-[14px] leading-[20px] font-[500] sm:font-normal md:leading-[24px] mt-8 mb-16 text-[var(--cbk-review-color)]">{t("cbk_please_review")}</p>
                        <div className='flex flex-row gap-2 cursor-pointer mt-8'
                        >
                            <img src={disclosureAgrmt ? RadialFill : appThemeData.radialnull} alt="Fill"
                                className={`${'h-[25px] w-[25px] sm:h-[23px] sm:w-[23px]  md:h-[25px] md:w-[25px]'}`}
                                onClick={() => { setDisclosureAgrmt(!disclosureAgrmt); if (!disclosureAgrmt) { setinfoMessage('') } }}
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key) setDisclosureAgrmt(!disclosureAgrmt);
                                    if (!disclosureAgrmt) {
                                        { setinfoMessage('') }
                                    }
                                }
                                }
                            />
                            <p className='sm:w-[25rem] w-full font-hanken-grotesk font-[500] sm:font-[700] text-[14px] 
                            leading-[20px] sm:text-[12px] sm:leading-[20px] md:text-[15px] md:leading-[24px]
                             text-[var(--i-have-read-color)]'>{t('i_have_read_and_agree')}
                                <span  className="text-[var(--conditions-clr)] font-hanken-grotesk"> {t('coveredby_kudzu_Plus_terms')}</span></p>
                        </div>
                        {infoMessage &&
                            <div className='mb-2 w-4/5 self-center justify-center'>
                                {displayErrorMessage(infoMessage)}
                            </div>
                        }
                           <p className="font-hanken-grotesk lg:text-[15px] md:text-[16px] sm:text-[10] sm:leading-[16px]
                         text-[12px] leading-[20px] font-[500] sm:font-normal md:leading-[24px] mt-8 mb-16 text-[var(--cbk-review-color)]">{t("cbk_by_clicking")}</p>
                        <div className="flex justify-center text-center w-full items-center lg:mt-14 mt-12">
                            <button
                                type="button"
                                className="w-full font-hanken-grotesk sm:font-bold font-[600] 
                                lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-white
                                 bg-[#2965FB] cursor-pointer flex justify-center items-center p-4 focus:outline-none  "
                                 onClick={() => {if (disclosureAgrmt) {setinfoMessage('');coveredByKudzuPlusOptIn();} else {setinfoMessage(t('please_accept_coveredbykudzu_terms'));}logFirebaseEvents("Covered_By_Kudzu", "Activated_Covered_By_Kudzu_Clicked", "Activated_Covered_By_Kudzu_Clicked","", ""); }}
                               
                                autoFocus
                            >
                                {'Activate Covered by Kudzu+'}
                            </button>
                        </div>

                    </div>}
                />}   

                 {isCoveredByKudzuOptInSuccess && <Modal
                    isOpen={true}
                    onClose={closeCustomAlertModal}
                    isClimbg={true}
                    Fullheight={true}
                    title={<p className={`${SubHeadingStyles21} mb-0`}>{t('congrats')}</p>}
                    subtitle={<div className=" sm:flex sm:flex-col">
                        {/* <span className={SubHeadingStyles2}>{t('congrats')}</span> */}
                        <span className={`${SubHeadingStyles} w-[437px]`}>{t('u_r_now_cbk_plus')}</span>
                        <p className='font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px]  text-[var(--matter-content-clr)] pt-5 w-[455px]'>{optinSuccessPopMessageFun(isCoveredByKudzuOptedIn)}</p>
                    </div>
                    }
                    content={<div className=" pb-5">
                        <img src={appThemeData.diag} className="block m-auto w-[31%] py-5 my-10" alt="" />
                        <div className="flex justify-center text-center w-full items-center">
                            <button
                                type="button"
                                className="focus:outline-none   w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                                onClick={() => { navigate('/Toolkit/ToolkitMenu')}}
                                autoFocus
                            >
                                {'Back to Toolkit'}
                            </button>
                        </div>
                    </div>}
                />
                    }   

        <CustomAlertModel isOpen={showModel}
        onClose={closeCustomAlertModal}
        image={modelImage}
        modalBg={!isSubFooter && 'bg-[var(--text-bg-subway)]'}
        btn1BorderColor={!isSubFooter && '#30BC89'}
        btn1TextColor={!isSubFooter && '#FEFAEE'}
        btn1BrExist={!isSubFooter && kudzuPlusTrue ? false : true}
        btn2TextColor={'#559C7E'}
        btn1BgColor={!isSubFooter && kudzuPlusTrue ? "" : '#30BC89'}
        highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
          <span className={`${HeaderMsgStyles} ${savingsTheme ? 'text-[var(--text-clr-secondary6)]' : 'text-black'}`}> {headerMsg}</span></p>}
        // highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
        // HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text} btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        verificationFailure={() => { }}
        footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
        onAcptBtnClick={onAcptBtnClick}
        onCancelBtnClick={onCancelBtnClick}
        isBorderNone={isBorderNone}
        subFooter={isSubFooter && subComponent()}
      />


            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
            onBack={() => {
              if (comparisonClickFrom == 'cancelledSuccesfully') {
                  handleComparisonBackClick()
              } else {
                  closeModelPlus()
              }

          }}
                image={modelImage}
                carousel={carousel}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}><span className='text-[#94C3E8] font-serif-pro'>{btn1Text === t('Downgrade_to_Kudzu') ? t('are_you_sure') : ""}</span><span>{headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgPlusStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                borderGradientrouneded={true}
                btn1TextColor={
                btn1Text === t('Downgrade_to_Kudzu')
                ? "#94C3E8"
                : (btn1TextColor ? btn1TextColor : "#ffffff")
                }
                btn2TextColor={'#779CE5'}
                borderWhite={'2px solid #94C3E8'}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
                allButtonsDisable={allButtonsDisable}
                footerText={footerText}
                comparisonScreen={comparisonScreen}
                fullWidth={fullWidth} 
            />

            {isLoading && <Loader />}
        </HomeLayout>


    )
}

export default ManageMembershipKudzuPlus;
